export enum TNotificationTypeEnum {
  info = 'info',
  error = 'error',
  warning = 'warning',
  success = 'success',
}
